import { createReducer } from '@lib/plugin-redux-core';
import {
  Assignment,
  AssignmentProps,
  AttendeeDetail,
  EssayAnswer,
  FillInBlankGroupAnswer,
  GET_ANSWERS_USE_CASE,
  GET_ASSIGNMENT_BY_ID_USE_CASE,
  GET_ATTENDEE_BY_ID_USE_CASE,
  GET_SUBMISSION_BY_ID_USE_CASE,
  MultipleChoiceAnswer,
  MatchingAnswerGroup,
  SingleChoiceAnswer,
  SpeakingAnswer,
  Submission,
  UPDATE_SUBMISSION_USE_CASE,
} from '@module/assignment';
import {
  FIND_FORM_RELEASE_BY_ID_USE_CASE,
  FIND_QUESTION_RELEASES_USE_CASE,
  FormRelease,
  QuestionRelease,
  QuestionReleaseProps,
} from '@module/form';
import { UseCaseError } from '@digibricks/core';
import {
  handleGetSubmissionById,
  handleGetAssignmentByIdUseCase,
  handleGetFormReleaseByIdUseCase,
  handleGetQuestionReleasesUseCase,
  handleGetAttendeeByIdUseCase,
  handleGetAnswersUseCase,
  handleUpdateSubmissionUseCase,
} from './submission-preview.handler';

export enum SubmissionPreviewPageStatus {
  EXECUTING,
  SUCCESS,
  ERROR,
  RESET,
}

export type SubmissionPreviewPageInitialState = {
  error?: UseCaseError<any>;
};

export type GetSubmissionByIdUseCaseState = {
  submission: Submission;
  getSubmissionByIdStatus: SubmissionPreviewPageStatus;
};

export type GetAssignmentByIdUseCaseState = {
  assignment: Assignment<AssignmentProps>;
  getAssignmentByIdStatus: SubmissionPreviewPageStatus;
};

export type GetFormReleaseByIdUseCaseState = {
  formRelease: FormRelease;
  getFormReleaseByIdStatus: SubmissionPreviewPageStatus;
};

export type GetAttendeeByIdUseCaseState = {
  attendeeDetail: AttendeeDetail;
  getAttendeeByIdStatus: SubmissionPreviewPageStatus;
};

export type GetQuestionReleasesUseCaseState = {
  questionReleases: QuestionRelease<QuestionReleaseProps>[];
  getQuestionReleasesStatus: SubmissionPreviewPageStatus;
};

export type GetSubmissionAnswersUseCaseState = {
  answers: (
    | EssayAnswer
    | SingleChoiceAnswer
    | FillInBlankGroupAnswer
    | MultipleChoiceAnswer
    | MatchingAnswerGroup
    | SpeakingAnswer
  )[];
  getAnswersStatus: SubmissionPreviewPageStatus;
};

export type SubmissionPreviewPageState = SubmissionPreviewPageInitialState &
  GetSubmissionByIdUseCaseState &
  GetAssignmentByIdUseCaseState &
  GetFormReleaseByIdUseCaseState &
  GetQuestionReleasesUseCaseState &
  GetAttendeeByIdUseCaseState &
  GetSubmissionAnswersUseCaseState & {
    updateSubmissionStatus?: SubmissionPreviewPageStatus;
  };

export const initialState: SubmissionPreviewPageInitialState = {
  error: null,
};

export const submissionPreviewReducer = createReducer(initialState, [
  {
    name: GET_SUBMISSION_BY_ID_USE_CASE,
    ...handleGetSubmissionById,
  },
  {
    name: GET_ASSIGNMENT_BY_ID_USE_CASE,
    ...handleGetAssignmentByIdUseCase,
  },
  {
    name: FIND_FORM_RELEASE_BY_ID_USE_CASE,
    ...handleGetFormReleaseByIdUseCase,
  },
  {
    name: GET_ATTENDEE_BY_ID_USE_CASE,
    ...handleGetAttendeeByIdUseCase,
  },
  {
    name: FIND_QUESTION_RELEASES_USE_CASE,
    ...handleGetQuestionReleasesUseCase,
  },
  {
    name: GET_ANSWERS_USE_CASE,
    ...handleGetAnswersUseCase,
  },
  {
    name: UPDATE_SUBMISSION_USE_CASE,
    ...handleUpdateSubmissionUseCase,
  },
]);
